module.exports = __webpack_public_path__ + "img/email-action-edit.a799dcb4.svg";